import { Instrument, OrderEntity, Portfolio } from "../../domain/entities/OrdersEntity";
import { enrichOrder } from "../../infrastructure/OrderMapper";
import {
    useGetInstruments,
    useGetOrders,
    useGetPortfolios,
    useGetRates,
} from "./useOrdersQueries";

import { useMemo } from "react";

type OptionItem = { id: number | string; name: string; detail?: string };

const mapToOptions = (data: OptionItem[] = []) => {
    return data.map(({ id, name, detail }) => ({
        detail,
        label: name,
        value: id.toString(),
    }));
}

export const useOrdersData = () => {
    const { data: ordersData, isLoading: ordersIsLoading, refetch: ordersRefetch } = useGetOrders();
    const { data: portfoliosData, isLoading: portfoliosIsLoading } = useGetPortfolios();
    const { data: instrumentsData, isLoading: instrumentsIsLoading } = useGetInstruments();
    const { data: ratesData, isLoading: ratesIsLoading } = useGetRates();

    const portfolios = portfoliosData?.data || [];
    const portfolioOptions = useMemo(() => mapToOptions(portfoliosData?.data), [portfoliosData]);
    const instruments = instrumentsData?.data || [];
    const instrumentOptions = useMemo(() => mapToOptions(
        instruments.map(instrument => ({
            id: instrument.id,
            name: instrument.mnemonic,
            detail: `(${instrument.interestRate} - ${instrument.frequency} - ${instrument.issuanceDate} - ${instrument.maturityDate})`
        }))), [instrumentsData]);
    const rates = ratesData?.data || [];

    const orders: OrderEntity[] = [];
    if (ordersData?.data) {
        ordersData.data.map((item) => {
            const { id, status, portfolio, instrument, orderType, quantity, rate, value, createdAt, updatedAt, confirmNumber } = item;


            const enrichedItem = enrichOrder(
                {
                    status,
                    portfolio,
                    orderType,
                    instrument,
                    quantity,
                    rate,
                    value,
                    confirmNumber,
                },
                id,
                new Date(createdAt),
                updatedAt ? new Date(updatedAt) : null,
                {
                    portfolios: portfoliosData?.data as unknown as Portfolio[],
                    instruments: instrumentsData?.data as unknown as Instrument[]
                }
            );

            if (enrichedItem) {
                orders.push(enrichedItem);
            }
        });
    }

    const isLoading =
        ordersIsLoading ||
        portfoliosIsLoading ||
        instrumentsIsLoading ||
        ratesIsLoading;

    return {
        orders,
        portfolios,
        portfolioOptions,
        instruments,
        instrumentOptions,
        rates,
        isLoading,
        ordersRefetch,
    };
}
